import React from 'react';
import propTypes from 'prop-types';

import { guidelineDeliveryTypeOptions, monthNumberLabel } from '../../../../constants';

const TitleGuideline = ({ guideline, short = false }) => {
  const isReview =
    guideline?.deliveryType === 'REVIEW' || guideline?.deliveryType === 'REVIEW_AND_DIRECTIONS';
  const subject = isReview
    ? guideline?.reviewLink
    : guideline?.primaryKeyword &&
      guideline.primaryKeyword.charAt(0).toUpperCase() + guideline.primaryKeyword.slice(1);

  // Older guidelines have no `count`
  const parts = short
    ? [guideline?.totalSize, subject]
    : [
        guideline?.count,
        monthNumberLabel.find((month) => month.value === parseInt(guideline?.productionDate?.month))
          ?.label,
        guidelineDeliveryTypeOptions.find((type) => type.value === guideline?.deliveryType)?.label,
        guideline?.totalSize,
        subject,
      ];

  return (
    <p>{parts.filter((part) => part !== undefined && part !== null && part !== '').join(' | ')}</p>
  );
};

TitleGuideline.propTypes = {
  guideline: propTypes.object,
  short: propTypes.bool,
};

export default TitleGuideline;
